module.exports = __webpack_public_path__ + "img/affirm_payment_plan_mobile.2835a74.svg";